import graph from './graph';
import { firebaseVapidKey } from 'config';
import { messaging } from 'helpers/firebase';
import { useEffect, useState } from 'react';
import { useMutation } from '@apollo/client';
import { useDispatch, useSelector } from 'react-redux';
import { getToken, isSupported } from 'firebase/messaging';
import { setDeviceToken } from 'toolkits/redux/setting';

const useFCMToken = () => {
  const dispatch = useDispatch();
  const [fcmToken, setFcmToken] = useState();
  const { userToken } = useSelector((state) => state.auth);
  const [subscription, { loading }] = useMutation(graph.subscription.query);
  const { isAuthenticated } = useSelector((state) => state.auth);
  const { notificationPermissionPrompt } = useSelector((state) => state.setting);

  const handleUserDevice = async (deviceToken) => {
    try {
      const {
        data: {
          subscription: { messages },
        },
      } = await subscription({
        variables: {
          zone: 'web',
          token: deviceToken,
        },
        context: {
          headers: {
            authorization: isAuthenticated ? `Bearer ${userToken}` : undefined,
          },
        },
      });
      if (messages) {
        dispatch(setDeviceToken(deviceToken));
      }
    } catch (error) {}
  };

  const retrieveToken = async () => {
    try {
      if (notificationPermissionPrompt === 'granted') {
        const isFCMSupported = await isSupported();
        if (!isFCMSupported) return;
        const fcmToken = await getToken(messaging(), {
          vapidKey: firebaseVapidKey,
        });
        if (fcmToken) {
          setFcmToken(fcmToken);
          handleUserDevice(fcmToken);
        }
      }
    } catch (error) {
      console.log('retrieveToken', error);
    }
  };

  useEffect(() => {
    retrieveToken();
  }, [notificationPermissionPrompt, isAuthenticated]);

  return { fcmToken, loading };
};

export default useFCMToken;
